module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-15-min.98082bc7.jpg";